import { SUPER_ADMIN } from "@/components/data/constants";
import { useActiveSession } from "@/hooks/useActiveSession";
import { isFormAssistantEnabled } from "./isFormAssistantEnabled";

// Super admins only until the assistant is signed off for other users; the
// backend enforces the same rule.
export function useFormAssistantAccess(): boolean {
  const { userType } = useActiveSession();
  return isFormAssistantEnabled() && userType === SUPER_ADMIN;
}
